export const creacionDivOpacidad = (contenedorCapa, layer) => {
  const divControlOpacidad = document.createElement("div");
  divControlOpacidad.className = "control-opacidad";

  const label = document.createElement("label");
  label.innerText = "Opacidad: ";

  const valorOpacidad = document.createElement("span");
  valorOpacidad.innerText = "100"; // valor inicial visible

  const botonMenos = document.createElement("button");
  botonMenos.textContent = "-";

  const botonMas = document.createElement("button");
  botonMas.textContent = "+";

  let opacidadActual = 1;

  const actualizarOpacidad = () => {
    // Clamp entre 0 y 1
    opacidadActual = Math.min(1, Math.max(0, opacidadActual));
    layer.setOpacity(opacidadActual);
    valorOpacidad.innerText = opacidadActual.toFixed(2) * 100 + "%";
  };

  botonMenos.addEventListener("click", () => {
    opacidadActual -= 0.1;
    actualizarOpacidad();
  });

  botonMas.addEventListener("click", () => {
    opacidadActual += 0.1;
    actualizarOpacidad();
  });

  actualizarOpacidad();

  divControlOpacidad.appendChild(label);
  divControlOpacidad.appendChild(botonMenos);
  divControlOpacidad.appendChild(valorOpacidad);
  divControlOpacidad.appendChild(botonMas);

  contenedorCapa.appendChild(divControlOpacidad);
};
